import useNetworks from '../../../../src/composables/use-networks';
import { useFeatureFlagsStore } from '../../../../stores';

export default {
    data() {
        const flags = useFeatureFlagsStore().data;
        return {
            flags,
            uploadedContent: {
                isFileUploading: false,
                isFileCanceling: false,
                delivering: false,
                isReady: false,
                errorMessage: null,
                errors: {
                    url: null,
                    impressions: null,
                    likes: null,
                    comments: null,
                    views: null
                }
            }
        };
    },

    methods: {
        isMeta(job) {
            return useNetworks().isMetaUploadContentDeliveryNetworkBySlugAndMediaType(
                job?.task?.network?.slug,
                job?.task?.media_type
            );
        },
        contactNetwork(job) {
            return this.$root.networks?.find((network) => network.network?.id === job?.task?.network_id);
        },
        showUploadedContentDelivery(job, brandNetworks) {
            return useNetworks().showUploadedContentDeliveryForNetwork(
                job?.task?.network_id,
                this.contactNetwork(job),
                brandNetworks,
                null,
                job?.task?.network?.slug,
                job?.task?.media_type
            );
        },
        handleUploadedContentFileChange(info) {
            if (this.uploadedContent.isFileCanceling) {
                this.uploadedContent.isFileCanceling = false;
                return;
            }

            this.uploadedContent.isFileUploading = true;
            this.handleUploadChange(
                info,
                () => (this.uploadedContent.isFileUploading = false),
                () => {
                    this.handleUploadError(info);
                    this.uploadedContent.isFileUploading = false;
                },
                true
            );
        },
        handleUploadedContentIsReady(isReady) {
            this.uploadedContent.isReady = isReady;
        },
        handleDeliverUploadedContent() {
            this.uploadedContent.delivering = true;
        },
        handleDeliveredUploadedContent() {
            this.uploadedContent.delivering = false;
            this.$root.reloadContact('jobs');
            this.$root.reloadContact('proposals');
            this.showDeliver(this.delivering);
        },
        handleUploadFailed() {
            this.uploadedContent.isFileUploading = false;
            this.uploadedContent.isFileCanceling = true;
        }
    }
};
